// src/services/auth.js
import { api } from "./api";

export const auth = {
  // existing
  me: () => api.get("/api/auth/me"),
  register: (payload) => api.post("/api/auth/register", payload),
  verifyOtp: (email, code, purpose = "register") =>
    api.post("/api/auth/verify-otp", { email, code, purpose }),
  resendOtp: (email, purpose = "register") =>
    api.post("/api/auth/request-otp", { email, purpose }),
  login: (email, password) => api.post("/api/auth/login", { email, password }),
  logout: () => api.post("/api/auth/logout"),

  // NEW — reset link flow
  // 1) request reset link (sends email with tokenized link)
  requestPasswordResetLink: (email) =>
    api.post("/api/auth/forgot/request", { email }),

  // 2) validate token before showing reset form
  validateResetToken: (email, token) =>
    api.get("/api/auth/forgot/validate", { params: { email, token } }),

  // 3) perform the reset with email + token + newPassword
  performPasswordReset: (email, token, newPassword) =>
    api.post("/api/auth/forgot/perform", { email, token, newPassword }),
};

export default auth;
